import styled from 'styled-components';
import {Flexbox, IconClose} from '@/styled-components';
import {palette} from '@/styles';
import {typographyStyle} from '../Typography';

export const Chip = styled(Flexbox)`
  border: solid 1px ${palette.gray200};
  color: ${palette.gray800};
  padding: 7px 12px;
  border-radius: 24px;
  white-space: nowrap;
  gap: 4px;
  ${{...typographyStyle.medium12}}
  ${IconClose} {
    cursor: pointer;
  }
`;
